export default "__VITE_ASSET__ByzqZeMK__"